import React, { useEffect } from "react";
import { Box, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

import { loadGoogleMaps } from "../../../utils/loadGoogleMaps";

const MapSection = styled(Paper)(({ theme }) => ({
  height: "100%",
  minHeight: "450px",
  boxShadow: theme.shadows[6],
  borderRadius: "16px",
  overflow: "hidden",
  display: "flex",
  marginBottom: "64x", // ✅ espacio para que no invada el footer
}));

const DestinoMap = ({ destino }) => {
  useEffect(() => {
    if (!destino) return;

    const initMap = () => {
      const { latitud, longitud, nombre } = destino;
      const lat = parseFloat(latitud);
      const lng = parseFloat(longitud);

      if (isNaN(lat) || isNaN(lng)) {
        console.error("Coordenadas inválidas:", latitud, longitud);
        return;
      }

      const mapOptions = {
        center: { lat, lng },
        zoom: 15,
      };

      const map = new window.google.maps.Map(
        document.getElementById("map"),
        mapOptions
      );

      new window.google.maps.Marker({
        position: mapOptions.center,
        map,
        title: nombre,
      });
    };

    loadGoogleMaps(initMap);
  }, [destino]);

  return (
    <MapSection sx={{ flex: 1 }}>
      <Box
        id="map"
        sx={{
          width: "650px",
          height: "100%",
        }}
      />
    </MapSection>
  );
};

export default DestinoMap;
